import { Skeleton, SkeletonProps } from "antd";
import { CSSProperties } from "react";
import styled from "styled-components";

export enum SkeletonType {
    avatar = "avatar",
    box = "box",
    input = "input",
    button = "button",
    line = "line",
}

type SkeletonLoadingProps = {
    type?: SkeletonType;
    props?: SkeletonProps;
    size?: number;
    sizes?: number[];
    width?: number;
    height?: number;
    style?: CSSProperties;
    children?: React.ReactElement;
    isLoading?: boolean;
};

export const SkeletonLoading = ({
    props,
    size,
    sizes,
    type,
    width,
    height,
    style,
    children,
    isLoading,
}: SkeletonLoadingProps) => {
    if (!isLoading) return <>{children}</>;

    if (props?.avatar || type === SkeletonType.avatar) {
        return <Skeleton.Avatar active size={size ?? 60} {...props} style={{ ...style }} />;
    }

    if (type === SkeletonType.box) {
        return (
            <StyledSkeleton
                active
                style={{ height: height, width: width ?? "100%", ...style }}
                {...props}
            />
        );
    }

    if (type === SkeletonType.input) {
        return (
            <>
                <StyledSkeleton active style={{ height: 18, width: 84, ...style }} {...props} />
                <StyledSkeleton
                    active
                    style={{ height: 53, width: width ?? "100%", ...style }}
                    {...props}
                />
            </>
        );
    }

    if (type === SkeletonType.button) {
        return (
            <>
                <StyledSkeleton
                    active
                    style={{ height: 52, borderRadius: "30px", width: "100%", ...style }}
                    {...props}
                />
            </>
        );
    }

    if (type === SkeletonType.line) {
        return (
            <>
                {sizes?.map((s) => (
                    <StyledSkeleton
                        active
                        style={{ height: 10, width: s + "%", borderRadius: 3, ...style }}
                        {...props}
                    />
                ))}
            </>
        );
    }

    return <>{children}</>;
};

export const StyledSkeleton = styled(Skeleton.Input)`
    .ant-skeleton-input {
        width: 100%;
    }
`;
